import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGenericPayload } from "../../../../models/common/IGenericPayload";
import { emptyStatisticsFilter, IStatisticsFilter } from "../../../../models/statistics/IStatisticsFilters";

interface IStatiticsReaderRecordRatioFilterState {
    filter: IStatisticsFilter;
}

const initialState: IStatiticsReaderRecordRatioFilterState = {
    filter: emptyStatisticsFilter(),
};

export const statisticsReaderRecordRatioFilterSlice = createSlice({
    name: "statisticsReaderRecordRatioFilterSlice",
    initialState,
    reducers: {
        resetReaderRecordRatioFilter: () => initialState,
        updateFilterProperty: (state, action: PayloadAction<IGenericPayload>) => {
            state.filter = {
                ...state.filter,
                [action.payload.name]: action.payload.value,
            };
        },
    },
});

export const { resetReaderRecordRatioFilter, updateFilterProperty } = statisticsReaderRecordRatioFilterSlice.actions;

export default statisticsReaderRecordRatioFilterSlice.reducer;
